module.exports = __webpack_public_path__ + "img/blug_bg_400.4ce4e54b.png";